export const HOME = {
  emergentLink: "home-emergent-link",
  uploadInput: "upload-input",
  uploadDropzone: "upload-dropzone",
  modeMix: "mode-mix",
  modeMastering: "mode-mastering",
  genreSelect: "genre-select",
  analyzeBtn: "analyze-btn",
  clearBtn: "clear-btn",
  goToDashboardBtn: "go-dashboard-btn",
  historyItem: "history-item",
};

export const ANALYSIS = {
  dashboard: "analysis-dashboard",
  hitCard: "hit-potential-card",
  danceCard: "danceability-card",
  metricCard: "metric-card",
  overallFeedback: "overall-feedback",
  improvementItem: "improvement-item",
  optimizeBtn: "optimize-btn",
  downloadBtn: "download-btn",
  originalPlayer: "original-player",
  optimizedPlayer: "optimized-player",
  compareBtn: "compare-btn",
  compareInput: "compare-input",
  compareResult: "compare-result",
  backHome: "back-home",
};
